import React from 'react';
import { Route } from 'react-router-dom';
import ParentLayout from '../components/ParentLayout';

export default (
  <Route path='/'>
    <ParentLayout/>
  </Route>
);
